// import { Map } from '@anov/geo-3d'
// import type { Vector3 } from 'three'
// import type { EarthOptions, ImageryLayers, Polygon, TerrainLayer } from '@anov/geo-3d'
// import type SceneControl from '../scene/scene'

// type MapOptions = {
//   // 中心点坐标
//   center: Vector3
//   // 影像提供者
//   imageryLayers?: ImageryLayers
//   // 地形提供者
//   terrainLayer?: TerrainLayer
//   // 静态资源路径
//   staticPath?: string
//   // 接收阴影
//   receiveShadow?: boolean
//   // 投射阴影
//   castShadow?: boolean
//   // 地图距离单位，默认米
//   unit?: number
//   extents?: Polygon | Polygon[] // 地图的数据范围,存经纬度
//   excludeExtents?: Polygon[] // 地图上挖除的数据范围，存经纬度
//   earthOptions?: EarthOptions// 三维地球参数
// }

// class MapControl {
//   private mapInstance: Map | null = null
//   private options!: MapOptions

//   constructor(options: MapOptions) {
//     this.options = options
//     // 使用 Proxy 代理，将所有属性和方法调用转发到 mapInstance
//     return new Proxy(this, {
//       get(target, prop, receiver) {
//         // 如果是 MapControl 自己的属性/方法，直接返回
//         if (prop in target)
//           return Reflect.get(target, prop, receiver)

//         // 如果 mapInstance 不存在，抛出错误提示需要先调用 render
//         if (!target.mapInstance)
//           throw new Error(`MapControl: 请先调用 render() 方法初始化地图后再访问 "${String(prop)}"`)

//         // 代理到 mapInstance
//         const value = Reflect.get(target.mapInstance, prop)

//         // 如果是方法，绑定 this 到 mapInstance
//         if (typeof value === 'function')
//           return value.bind(target.mapInstance)

//         return value
//       },

//       set(target, prop, value, receiver) {
//         // 如果是 MapControl 自己的属性，直接设置
//         if (prop in target)
//           return Reflect.set(target, prop, value, receiver)

//         // 如果 mapInstance 不存在，抛出错误
//         if (!target.mapInstance)
//           throw new Error(`MapControl: 请先调用 render() 方法初始化地图后再设置 "${String(prop)}"`)

//         // 代理到 mapInstance
//         return Reflect.set(target.mapInstance, prop, value)
//       },
//     })
//   }

//   render(sceneControl: SceneControl) {
//     if (this.mapInstance) {
//       console.warn('MapControl: render() 已经被调用过，将返回现有实例')
//       return this
//     }

//     const { scene, controls, camera, renderer } = sceneControl
//     this.mapInstance = new Map({
//       threeModule: { scene, control: controls, camera, renderer },
//       ...this.options,
//     })

//     return this
//   }
// }

// export default MapControl